import { Box, Typography } from '@mui/material'
import SubdirectoryArrowRightIcon from '@mui/icons-material/SubdirectoryArrowRight'

type DetailFieldProps = {
  label: string
  children: React.ReactNode
  // when set, the value shown is not set on this record and comes from the named parent (e.g. "Region"),
  // or "Default" when nothing in the chain sets it
  inheritedFrom?: string
}
/**
 * @description Label/value pair for detail pages.
 */
export const DetailField = (props: DetailFieldProps) => {
  const { label, children, inheritedFrom } = props
  return (
    <Box sx={{ minWidth: 0 }}>
      <Typography
        variant="caption"
        component="div"
        sx={{ color: 'grey.500', textTransform: 'uppercase', fontWeight: 500 }}
      >
        {label}
      </Typography>
      <Box
        sx={{
          typography: 'body1',
          display: 'flex',
          flexWrap: 'wrap',
          alignItems: 'center',
          gap: 1,
          overflowWrap: 'anywhere',
        }}
      >
        {children}
      </Box>
      {inheritedFrom && (
        <Typography
          variant="caption"
          component="div"
          sx={{ color: 'grey.500', display: 'flex', alignItems: 'center', gap: 0.5 }}
        >
          <SubdirectoryArrowRightIcon sx={{ fontSize: 14 }} />
          {inheritedFrom === 'Default' ? 'Default value' : `Inherited from ${inheritedFrom}`}
        </Typography>
      )}
    </Box>
  )
}

/**
 * @description Responsive grid for laying out several DetailFields side by side.
 */
export const DetailFieldGrid = (props: { children: React.ReactNode; minColumnWidth?: number }) => {
  const { children, minColumnWidth = 180 } = props
  return (
    <Box
      sx={{
        display: 'grid',
        gap: 2,
        gridTemplateColumns: `repeat(auto-fill, minmax(${minColumnWidth}px, 1fr))`,
      }}
    >
      {children}
    </Box>
  )
}
